export default __webpack_public_path__ + "static/media/angle_right.3d39fdd8.svg";